import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api, getToken, isEmbedded, persistToken, setUnauthorizedHandler } from "./noleggio";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    setUnauthorizedHandler(() => {
      persistToken(null);
      setUser(null);
    });
    (async () => {
      try {
        const m = window.location.href.match(/[?#&]session_id=([^&#]+)/);
        if (m) {
          window.history.replaceState(null, "", window.location.pathname + window.location.search.replace(/[?&]session_id=[^&]+/, ""));
          try {
            const res = await api("/auth/session", { method: "POST", body: { session_id: decodeURIComponent(m[1]) } });
            persistToken(res.session_token);
            setUser(res.user);
            return;
          } catch {}
        }
        if (getToken()) {
          try {
            setUser(await api("/auth/me"));
          } catch {
            persistToken(null);
          }
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api("/auth/login", { method: "POST", body: { email, password } });
    persistToken(res.token);
    setUser(res.user);
  }, []);

  const register = useCallback(async (name, email, password) => {
    const res = await api("/auth/register", { method: "POST", body: { name, email, password } });
    persistToken(res.token);
    setUser(res.user);
  }, []);

  const loginWithGoogle = useCallback(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = `${window.location.origin}/`;
    const url = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
    // Inside the Shopify page Google blocks sign-in, so it opens in a full tab.
    if (isEmbedded()) window.open(url, "_blank", "noopener");
    else window.location.href = url;
  }, []);

  const logout = useCallback(() => {
    persistToken(null);
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, loading, login, register, loginWithGoogle, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
